module.exports = __webpack_public_path__ + "static/management-40-full-0df99237814d9901468060b65c3d075f.png";